import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(matchMedia(query).matches);

  useEffect(() => {
    const media = matchMedia(query);
    setMatches(media.matches);

    function listener(event: MediaQueryListEvent) {
      setMatches(event.matches);
    }

    media.addEventListener('change', listener);
    // Deprecated method, Safari doesn't have `addEventListener` until version
    // 14, released in 2020-09-16. Remove whenever you feel comfortable :P
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
    media.addListener(listener);
    return () => {
      media.removeEventListener('change', listener);
      media.removeListener(listener);
    };
  }, [query]);

  return matches;
}
